import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { HistoryLayout } from '../../../../../common/history/history-layout.component';
import { TablePagination } from '../../../../../common/details-table/table-pagination.component';
import { debitorHistoryActions } from "../../../../../../store/external/recharge-reducer/history/debitor-history-reducer";
import { MODAL_CUSTOM_MESSAGE } from "../../../../../../constants/external-constants";


class DebitorCatalogueHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableSearchBox: false,
             exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        }

    }
    componentWillUnmount() {
        this.props.resetDebitorHistory()
    }
   
    componentDidMount() {
        this.props.getDebitorHistoryLogs(this.props.debitorId)
    }

    onColumnSearch = () => {
        const { getDebitorHistoryLogs, debitorId } = this.props;
        getDebitorHistoryLogs(debitorId, 0)
    }

    debitorPaginationAction = (pageIndex) => {
        const { getDebitorHistoryLogs, debitorId } = this.props;
        getDebitorHistoryLogs(debitorId, pageIndex);
    }

    resizePage = (pageSize) => {
        const { resizeDebitorHistoryLogs, getDebitorHistoryLogs, debitorId } = this.props;
        resizeDebitorHistoryLogs(pageSize)
        getDebitorHistoryLogs(debitorId);
    }

    displaySearchBox = (value) => {
        this.setState({ enableSearchBox: value })
    }

    onClickExtract = () => {
        const { debitorId, extractDebitorHistoryLogs } = this.props;
        if (window.confirm(this.state.exportAlertMsg)) {
            extractDebitorHistoryLogs(debitorId);
        }
    }  


    render() {
        const { setDebitorHistoryColSearchStr, isColSearchShow } = this.props;
        const { IsLoadingTable } = this.props.debitorHistory;
        const { Headers, Data, Pagination } = this.props.debitorHistory.HistoryTable;
        const {isReadOnly, isReadAndExtractOnly, isReadAndWrite } = this.props;
        return (
            <div>
            <HistoryLayout
             displaySearchBox={this.displaySearchBox}
             extractAction={this.onClickExtract}
             isViewing={this.props.isViewing}
            //Access Type
            isReadOnly={isReadOnly}
            isReadAndExtractOnly={isReadAndExtractOnly}
            isReadAndWrite={isReadAndWrite} 
            hideCustomColumn={true}
            >
                    <TablePagination
                        key="table-pagination-key"
                        columns={Headers}
                        pageList={Data}
                        pages={Pagination}
                        paginationAction={this.debitorPaginationAction}
                        onColumnSearch={this.onColumnSearch}
                        onColumnSearchChange={setDebitorHistoryColSearchStr}
                        isColSearchShow={this.state.enableSearchBox}
                        resizePage={this.resizePage}
                        totalPage={Pagination.TotalEntries}
                        isNotSortable={true}
                        isLoading={IsLoadingTable}
                        hideStatusIcon={true}
                    // isLoading={IsLoadingTable}    
                />
            </HistoryLayout>
        </div>
        );
    }
}


export default connect(
    state => {
        const { debitorHistory } = state;
        return {
            debitorHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, debitorHistoryActions),
        dispatch
    )
)(DebitorCatalogueHistory);